import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tutorialFilter',
})
export class TutorialFilterPipe implements PipeTransform {
  transform(array: any[], query: string): any {
    if (query) {
      return _.filter(array, (row) =>
      (
        row.titleEn.toLowerCase().indexOf(query.toLowerCase()) > -1
        || row.titleAr.indexOf(query.toLowerCase().replaceAll(" ", "")) > -1)
      );
    }
    return array;
  }
}


